import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { unicodeToString } from "../../../Js/Common";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import { shuffle } from "../../../Js/Common";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { List, Typography } from "@mui/material";
import { Box } from "@mui/system";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import OptionMedia from "../../../Components/Card/AssetUI/OptionMedia";
import StatusIndicator from "../../../Components/Card/AssetUI/StatusIndicator";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const JW = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  const [jwContent, setJwContent] = useState([]);
  const [logObj, setLogObj] = useState(initLogObj);
  const [received, setReceived] = useState([]);
  const [droppable, setDroppable] = useState("items");
  const [droppable2, setDroppable2] = useState("selected");
  const [currentIndexPlay, setCurrentIndexPlay] = useState([]);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } =
    useSelector((state) => state.currentAsset);

  useEffect(() => {
    if (props.content) {
      let actualAnswer = [
        unicodeToString(props.content.epage.options.content[0]["text"]),
      ];
      dispatch(currentAssetSliceActions.setCurrentAttemptData(null));

      console.log("props.content changed12121212", actualAnswer);
      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actualAnswer,
      });

      setJwContent(shuffle(actualAnswer[0].split(" ")));
      setReceived([]);
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    // let tempVar = [...rtsContent];
    // setRtsContent(shuffle(tempVar));
  }, [logObj]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setCurrentAttemptData(null));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    setJwContent(
      shuffle(
        unicodeToString(props.content.epage.options.content[0]["text"]).split(
          " "
        )
      )
    );
    setReceived([]);
    // let tempVar = [...rtsContent];
    // setRtsContent(shuffle(tempVar));
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      setReceived(
        unicodeToString(props.content.epage.options.content[0]["text"]).split(
          " "
        )
      );
      setJwContent([]);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setJwContent([]);
      setReceived([]);
    };
  }, []);

  useEffect(() => {
    updateUserAnswer();
  }, [received]);

  const updateUserAnswer = () => {
    if (!showAnswer && !attempted) {
      dispatch(
        currentAssetSliceActions.setCurrentAttemptData([
          received.join(" ").trim(),
        ])
      );
    }
  };

  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  /**
   * Moves an item from one list to another list.
   */
  const move = (source, destination, droppableSource, droppableDestination) => {
    var sourceClone, destClone;
    if (droppableSource.droppableId == "droppable") {
      sourceClone = Array.from(source);
      destClone = Array.from(destination);
    } else {
      sourceClone = Array.from(destination);
      destClone = Array.from(source);
    }

    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
  };

  const grid = 8;

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 ${grid}px 0 0`,

    // change background colour if dragging
    background: "#fff",

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    display: "flex",
    padding: grid,
    overflow: "auto",
  });

  const getListStyle1 = (isDraggingOver) => ({
    display: "flex",
    padding: grid,
    overflow: "auto",
    borderBottom: "2px solid #D9D9D9",
    width: "auto",
    marginTop: 30,
  });

  const onDragEnd = (result) => {
    console.log("*&*&", result);
    if (!showAnswer && !attempted) {
      const { source, destination } = result;

      // dropped outside the list
      if (!destination) {
        return;
      }

      if (source.droppableId === destination.droppableId) {
        if (source.droppableId === "droppable") {
          const items = reorder(jwContent, source.index, destination.index);
          setJwContent(items);
        } else {
          const items2 = reorder(received, source.index, destination.index);
          setReceived(items2);
        }
      } else {
        const result = move(jwContent, received, source, destination);

        console.log("result", result);

        setJwContent(result.droppable);
        setReceived(result.droppable2);
      }
    }
  };

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  return (
    <div  >
      {props.content && props.content?.epage?.options?.content[0].media && (
        <OptionMedia
          media={props.content?.epage?.options?.content[0].media}
          isPlaying={currentIndexPlay[0]}
          setPlayMode={(status, end) => {
            setPlayMode(status, 0, end);
          }}
        ></OptionMedia>
      )}
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable" direction="horizontal">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
              {...provided.droppableProps}
              className={classes.scrollBarHeight}
            >
              {jwContent &&
                jwContent.map((item, index) => (
                  <Draggable
                    key={`${index}_drag1`}
                    draggableId={`${index}_drag1`}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <Box
                        sx={{
                          lineHeight: 1,
                          border: 1,
                          borderColor: "#D9D9D9",
                          color: "primary.main",
                          fontWeight: "700",
                          fontSize: "0.9rem",
                          borderRadius: 10,
                          boxShadow: 0,
                          width: "auto",
                          cursor: "pointer",
                          display: "inline",
                          padding: 1,
                          marginX: 1,
                          textAlign: "center",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.4rem",
                            width: "auto",
                          },
                        }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        {item}
                      </Box>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        <Droppable droppableId="droppable2" direction="horizontal">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getListStyle1(snapshot.isDraggingOver)}
              className={classes.scrollBarHeight}
            >
              {optionWiseAns && optionWiseAns.length > 0 && (
                <StatusIndicator correct={optionWiseAns[0]}></StatusIndicator>
              )}
              {received &&
                received.map((item, index) => (
                  <Draggable
                    key={`${index}_drag2`}
                    draggableId={`${index}_drag2`}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <Box
                        sx={{
                          lineHeight: 1,
                          border: 1,
                          borderColor: "#D9D9D9",
                          color: "primary.main",
                          fontWeight: "700",
                          fontSize: "0.9rem",
                          borderRadius: 10,
                          boxShadow: 0,
                          width: "auto",
                          cursor: "pointer",
                          display: "inline",
                          padding: 1,
                          marginX: 1,
                          textAlign: "center",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.4rem",
                            width: "auto",
                          },
                        }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        {item}
                      </Box>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default JW;
